import React from "react";

const DotsRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="32"
      viewBox="0 0 32 32"
    >
      <g id="Raggruppa_577" transform="translate(-1562 -444)">
        <rect
          id="Rettangolo_297"
          width="32"
          height="32"
          transform="translate(1562 444)"
          fill="none"
        />
        <g id="Raggruppa_340" transform="translate(659.633 -463.533)">
          <path
            id="Tracciato_74"
            d="M827,791.637l-6.17,4.691,6.17,5.155"
            transform="translate(1750.697 1720.016) rotate(180)"
            fill="none"
            stroke="#1a1a1a"
            strokeLinecap="round"
            strokeWidth="2"
          />
          <g
            id="Ellisse_16"
            transform="translate(905.367 921.896)"
            fill="#1a1a1a"
            stroke="#1a1a1a"
            strokeWidth="1"
          >
            <circle cx="2" cy="2" r="2" stroke="none" />
            <circle cx="2" cy="2" r="1.5" fill="none" />
          </g>
          <g
            id="Ellisse_17"
            transform="translate(911.367 921.896)"
            fill="#1a1a1a"
            stroke="#1a1a1a"
            strokeWidth="1"
          >
            <circle cx="2" cy="2" r="2" stroke="none" />
            <circle cx="2" cy="2" r="1.5" fill="none" />
          </g>
          <g
            id="Ellisse_18"
            transform="translate(917.367 921.896)"
            fill="#1a1a1a"
            stroke="#1a1a1a"
            strokeWidth="1"
          >
            <circle cx="2" cy="2" r="2" stroke="none" />
            <circle cx="2" cy="2" r="1.5" fill="none" />
          </g>
        </g>
      </g>
    </svg>
  );
};

export default DotsRight;
